var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 12.0007L12.0002 13.334L14.6668 10.6673M14.6668 6.66732H1.3335M14.6668 8.00065V5.46732C14.6668 4.72058 14.6668 4.34721 14.5215 4.062C14.3937 3.81112 14.1897 3.60714 13.9388 3.47931C13.6536 3.33398 13.2802 3.33398 12.5335 3.33398H3.46683C2.72009 3.33398 2.34672 3.33398 2.06151 3.47931C1.81063 3.60714 1.60665 3.81111 1.47882 4.062C1.3335 4.34721 1.3335 4.72058 1.3335 5.46732V10.534C1.3335 11.2807 1.3335 11.6541 1.47882 11.9393C1.60665 12.1902 1.81063 12.3942 2.06151 12.522C2.34672 12.6673 2.72009 12.6673 3.46683 12.6673H8.00016",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIcon);
export default __webpack_public_path__ + "static/media/payments-icon.c881727ccbf3dd505b7be1dace962acf.svg";
export { ForwardRef as ReactComponent };